import HeatLoad from './HeatLoad';

export default HeatLoad;
